import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { usePropertyDisplay } from '../hooks/usePropertyDisplay';
import { useCardContextValue } from '../state/CardContext';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { usePropertyInputsContextValue } from '../state/PropertyInputsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputWrapper = ({
  propertyName,
  inputProps = {},
  formControlProps = {},
  onFocus,
  onBlur,
  isEditable = true,
  tooltipTitle
}) => {
  var _subjectPermissionsRe, _subjectPermissionsRe2, _propertyDefinitionsR;
  const {
    objectTypeId,
    objectId,
    asyncData: {
      propertyDefinitionsResult,
      subjectPermissionsResult
    }
  } = useCardContextValue();
  const {
    getDraftValue,
    getSavedValue,
    onSave,
    onChange,
    getPropertyValue
  } = usePropertyInputsContextValue();
  const {
    getPropertyDisplay
  } = usePropertyDisplay(objectTypeId, (_subjectPermissionsRe = (_subjectPermissionsRe2 = subjectPermissionsResult.data) === null || _subjectPermissionsRe2 === void 0 || (_subjectPermissionsRe2 = _subjectPermissionsRe2.crmObject) === null || _subjectPermissionsRe2 === void 0 ? void 0 : _subjectPermissionsRe2.userPermissions.currentUserCanEdit) !== null && _subjectPermissionsRe !== void 0 ? _subjectPermissionsRe : false);
  const propertyDefinition = (_propertyDefinitionsR = propertyDefinitionsResult.data) === null || _propertyDefinitionsR === void 0 ? void 0 : _propertyDefinitionsR.get(propertyName);
  if (!propertyDefinition) {
    return null;
  }
  const value = getPropertyValue(propertyName);
  const {
    isReadOnly
  } = getPropertyDisplay(propertyDefinition.property);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle !== null && tooltipTitle !== void 0 ? tooltipTitle : propertyDefinition.property.label,
    disabled: !value,
    children: /*#__PURE__*/_jsx(PropertyInputV2, {
      use: "floating",
      property: propertyDefinition.property,
      objectId: String(objectId),
      objectTypeId: objectTypeId,
      readOnly: isReadOnly || !isEditable,
      inputProps: Object.assign({
        placeholder: propertyDefinition.property.label
      }, inputProps),
      formControlProps: Object.assign({
        hoverContent: null,
        'data-test-id': `property-input-${propertyName}`,
        marginBlockStart: 0,
        label: null
      }, formControlProps),
      enableAutosave: true,
      getDraftValue: getDraftValue,
      getSavedValue: getSavedValue,
      onChange: onChange,
      onSave: onSave,
      value: value,
      enableConditionalPropertiesPanel: true,
      enableConditionalPropertyOptions: true,
      onFocus: onFocus,
      onBlur: onBlur
    }, propertyName)
  });
};
export default PropertyInputWrapper;